import PdfEmbed from "./PdfEmbed";
import InnerPageLayout from "../Components/Layout/InnerPageLayout";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";

function StructurePagePage() {
  const { i18n } = useTranslation();

  return (
    <InnerPageLayout>
      <>
        <Card className="mb-4">
        <Card.Header> {i18n.t('organization_structure')}</Card.Header>
        <Card.Body>
            <PdfEmbed embedURL="https://s3.tatweertransit.com/upload/structure.pdf" />
          </Card.Body>
        </Card>
      </>
    </InnerPageLayout>
  );
}

export default StructurePagePage;
